import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {graphql} from '@apollo/client/react/hoc/graphql';
import {bindField} from '@swipe-guide/clients-shared/utils/input-utils';
import isEmpty from 'lodash/isEmpty';

//components
import ContextMenuLink from 'components/Layout/PageTitle/ContextMenuLink';
import FormTextarea from 'components/Layout/Form/FormTextarea';
import {FormattedMessage} from '@swipe-guide/clients-shared/components/FormattedComponents';
import Recaptcha from '@swipe-guide/clients-shared/components/Recaptcha';
import Input from '@swipe-guide/clients-shared/components/Input';

//mutations
import {CreateFeedback} from '@swipe-guide/clients-shared/api/feedback/mutations';
import {createFeedbackOptions} from '@swipe-guide/clients-shared/api/feedback/mutation-options';

//messages
import messages from './messages';

//config
import {RECAPTCHA_SITE_KEY} from '@swipe-guide/clients-shared/constants';

import {Feedback, FeedbackContent, Label, SendButton, FeedbackItemWrapper, InputWrapper} from './styles';

@inject('store')
@graphql(CreateFeedback, createFeedbackOptions)
@observer
class FeedbackComponent extends Component {
  componentDidMount = async () => {
    const {
      store: {
        auth: {user},
        feedback: {setSaveLabels, setFullName}
      }
    } = this.props;

    const defaultUserName = user ? user.fullName : '';

    setFullName(defaultUserName);

    setSaveLabels(
      this.props.intl.formatMessage({...messages.feedback_send_label}),
      this.props.intl.formatMessage({...messages.feedback_sending_label})
    );
    document.body.addEventListener('click', this.handleClickOutside);
  };

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = event => {
    const {
      store: {feedback}
    } = this.props;
    const {toggleFeedback, opened, wrapperRef} = feedback;
    if (wrapperRef && !wrapperRef.contains(event.target) && opened) {
      toggleFeedback();
    }
  };

  submitFeedback = (createFeedbackMutation, sendFeedback) =>
    sendFeedback(
      this.recaptcha,
      createFeedbackMutation,
      this.props.intl.formatMessage({...messages.feedback_action_success}),
      this.props.intl.formatMessage({...messages.feedback_action_error})
    );

  render() {
    const {
      store: {feedback, platform},
      createFeedbackMutation
    } = this.props;
    const {
      form,
      toggleFeedback,
      opened,
      checkRecaptcha,
      sendFeedback,
      sendButtonText,
      disableFeedback,
      setWrapperRef,
      sending,
      fullName,
      setFullName
    } = feedback;

    const {isContentProtected} = platform;
    const showRecaptcha = !isEmpty(RECAPTCHA_SITE_KEY) && !isContentProtected;

    const feedbackTab = (
      <div>
        <Label>
          <FormattedMessage {...messages.feedback_give_us_your_feedback} />
        </Label>
        <FormTextarea {...bindField(form, 'text')} />
        <InputWrapper>
          <Input
            name="fullName"
            label={this.props.intl.formatMessage(messages.yourName)}
            isDesktop={true}
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            testId="user-feedback"
          />
        </InputWrapper>
        {showRecaptcha && (
          <Recaptcha
            ref={ref => (this.recaptcha = ref)}
            sitekey={RECAPTCHA_SITE_KEY}
            onResolved={() => this.submitFeedback(createFeedbackMutation, sendFeedback)}
          />
        )}
        <SendButton
          disabled={!form.isValid || sending}
          onClick={() => {
            showRecaptcha
              ? checkRecaptcha(this.recaptcha.execute)
              : this.submitFeedback(createFeedbackMutation, sendFeedback);
          }}
          isLoading={sending}
        >
          {sendButtonText}
        </SendButton>
      </div>
    );

    return (
      <FeedbackItemWrapper ref={setWrapperRef}>
        <ContextMenuLink
          onClick={e => {
            e.stopPropagation();
            toggleFeedback();
          }}
          iconName={'chat-bubble'}
          tag={'button'}
          disabled={disableFeedback}
          className={opened ? 'active' : null}
          data-cy="feedback-button"
        >
          <FormattedMessage {...messages.feedback_menu_label} />
        </ContextMenuLink>
        <Feedback opened={opened}>
          <FeedbackContent>{feedbackTab}</FeedbackContent>
        </Feedback>
      </FeedbackItemWrapper>
    );
  }
}

export default injectIntl(FeedbackComponent);
